import React, { useEffect, useState } from "react";

interface WhiteboardLinkProps {
  schoolCode: string | null;
  familyCode: string | null;
  login: string | null;
}

const WhiteboardLink: React.FC<WhiteboardLinkProps> = ({ schoolCode, familyCode, login }) => {
  const [link, setLink] = useState("");

  useEffect(() => {
    if (!schoolCode || !familyCode || !login) return;

    let isMounted = true;

    const fetchWhiteboardLink = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_DOCUMENT_LINK}get_profile_details/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            SchoolCode: schoolCode,
            FamilyCode: familyCode,
            Login: login,
          }),
        });

        if (!response.ok) {
          throw new Error(`Unable to load the shared whiteboard link (HTTP ${response.status}).`);
        }

        const data: { WhiteBoard?: string | null } = await response.json();
        if (isMounted && data.WhiteBoard?.includes("https://www.twiddla.com/")) {
          setLink(data.WhiteBoard);
        }
      } catch (error) {
        console.error("Failed to load the shared whiteboard link:", error);
      }
    };

    void fetchWhiteboardLink();

    return () => {
      isMounted = false;
    };
  }, [schoolCode, familyCode, login]);

  if (!link) return null;

  return (
    <span style={{ marginLeft: "104px" }}>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        style={{ fontSize: "11pt", color: "#333333", fontWeight: "bold" }}
      >
        Whiteboard
      </a>
    </span>
  );
};

export default WhiteboardLink;
